<template>
  <b-form-group>
    <h6 class="font-size-md">
      <span v-if="isRequired" class="ml-n1 text-danger">*</span>
      {{ label }}
    </h6>
    <div class="input-icon input-icon-sm">
      <b-row>
        <b-col :md="(date || '') !== '' ? 7 : ''">
          <b-form-datepicker
            v-model="date"
            :size="size"
            class="mb-2"
            :class="{'is-invalid': !isValid}"
            hide-header
            :readonly="isReadOnly"
            :disabled="isDisabled"
            :placeholder="placeholder"
          />
        </b-col>
        <b-col v-if="(date || '') !== ''">
          <b-form-timepicker
            v-model="time"
            :size="size"
            class="mb-2"
            :class="{'is-invalid': !isValid}"
            hide-header
            :readonly="isReadOnly"
            :disabled="isDisabled"
          />
        </b-col>
      </b-row>
      <div v-if="!isValid" class="invalid-feedback">
        {{ error }}
      </div>
      <div v-if="hint !== ''" class="mt-1 font-size-sm text-gray600">
        {{ hint }}
      </div>
    </div>
  </b-form-group>
</template>

<script>
import DateToFormatString from '@/utils/DateToFormatString';

export default {
  props: {
    value: {
      type: Number
    },
    error: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'sm'
    },
    validate: {
      type: Function,
      default() {
        return () => {};
      }
    },
    required: {},
    readonly: {},
    disabled: {}
  },
  data() {
    return {
      formValue: this.value
    };
  },
  computed: {
    isValid() {
      return (this.error || '') === '';
    },
    isRequired() {
      if (this.required === true) return true;
      if (this.required === false) return false;
      if (this.required === undefined) return false;
      if (this.required === '') return true;
      return false;
    },
    isReadOnly() {
      if (this.readonly === true) return true;
      if (this.readonly === false) return false;
      if (this.readonly === undefined) return false;
      if (this.readonly === '') return true;
      return false;
    },
    isDisabled() {
      if (this.disabled === true) return true;
      if (this.disabled === false) return false;
      if (this.disabled === undefined) return false;
      if (this.disabled === '') return true;
      return false;
    },
    date: {
      get() {
        if ((this.formValue || null) === null) return '';
        const date = new Date(this.formValue);
        return DateToFormatString(date, 'yyyy-MM-dd');
      },
      set(val) {
        const date = new Date(`${val} ${this.time}`);
        this.formValue = date.getTime();
      }
    },
    time: {
      get() {
        if ((this.formValue || null) === null) return '00:00:00';
        const date = new Date(this.formValue);
        return DateToFormatString(date, 'HH:mm:ss');
      },
      set(val) {
        const date = new Date(`${this.date} ${val}`);
        this.formValue = date.getTime();
      }
    }
  },
  watch: {
    formValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      if (val !== this.formValue) this.formValue = val;
    }
  },
  created() {
  },
  methods: {
    onFocus(e) {
      this.$emit('focus', e);
    },
    onBlur(e) {
      this.$emit('blur', e);
    }
  }
};
</script>
